import { List, Typography } from '@mui/material';
import React from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { ConsultantResultCard } from './ConsultantResultCard';
import { GetConsultantTextSearchQuery } from '../../../generated/graphql';

type SearchResultListProps = { list?: GetConsultantTextSearchQuery['organisationPublicSearch']; distanceMap?: Record<number, number> };

declare global {
    interface Window {
        __consultantMapFocus?: (organisationId: number) => void;
    }
}

export function SearchResultList({ list, distanceMap }: SearchResultListProps) {
    const { t } = useServerTranslation();
    if (list?.total === 0) {
        return <Typography component="div">{t('find-consultant.no-result')}</Typography>;
    }

    return (
        <List>
            {list?.items?.map((item, index) => (
                <ConsultantResultCard
                    key={index}
                    item={item}
                    distanceKm={distanceMap ? distanceMap[item.id] : undefined}
                    onFocusOnMap={() => window.__consultantMapFocus?.(item.id)}
                />
            ))}
        </List>
    );
}
